export class PlanComment {
    id!: string
    planKey!: string
    nodeId!: string
    nodeLabel!: string
    processName!: string
    comment!: string
    createdBy?: string
    createdByName?: string
    createdOn?: Date
    modifiedOn?: Date
}
